const actionsTypesMyQuestion={
    LOADING_SUCCESS_MY_QUESTIONS:"LOADING_SUCCESS_MY_QUESTIONS",
    LOAD_SUCCESS_MY_QUESTIONS:"LOAD_SUCCESS_MY_QUESTIONS",
    DELETE_SUCCESS:"DELETE_SUCCESS",
    LOAD_FAILURE_MY_QUESTIONS:"LOAD_FAILURE_MY_QUESTIONS"
}

export default actionsTypesMyQuestion